import React, { useEffect, useState, useRef } from 'react';
import './subscriptions.css';
import Header from "../../components/Header/Header";
import SubscriptionsHeader from "../../components/PagesHeaders/SubscriptionsHeader/SubscriptionsHeader";
import { useDispatch, useSelector } from "react-redux";
import { getSubscriptionsSagaAction } from "../../redux/sagaActions";
import Subscription from "../../components/Subscription/Subscription";
import SubscriptionForm from "../../components/SubscriptionForm/SubscriptionForm";
import SubscriptionCalendar from "../../components/SubscriptionCalendar/SubscriptionCalendar";
import AddSubscriptionForm from "../../components/AddSubscriptionForm/AddSubscriptionForm";
import ExtendSubscriptionForm from "../../components/ExtendSubscriptionForm/ExtendSubscriptionForm";
import CurrentWorkouts from "../../components/CurrentWorkouts/CurrentWorkouts";
import { sortAction, subscriptionsActiveOnlyAction, subscriptionsInactiveOnlyAction } from "../../redux/rootReducer";
import RepayMoneyForm from "../../components/RepayMoneyForm/RepayMoneyForm";
import FamilyForm from "../../components/FamilyForm/FamilyForm";
import Pagination from "../../components/Pagination/Pagination";

const Subscriptions = () => {
    const dispatch = useDispatch();
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const subscriptions = useSelector(state => state.subscriptions);
    const search = useSelector(state => state.search);
    const pagination = useSelector(state => state.pagination);
    const current_subscription = useSelector(state => state.current_subscription);
    const subscriptions_active_only = useSelector(state => state.subscriptions_active_only);
    const subscriptions_inactive_only = useSelector(state => state.subscriptions_inactive_only);
    const sort = useSelector(state => state.sort);
    const all_subscriptions_count = useSelector(state => state.all_subscriptions_count);
    const addSubscriptionForm = useSelector(state => state.addSubscriptionForm);

    const timer = useRef(null);

    const [firstRender, setFirstRender] = useState(false);

    // Функция смены страницы
    const changePage = page => {
        dispatch(getSubscriptionsSagaAction({
            page,
            date: subscriptions.current_month
        }));
    };

    // Фильтрация абонементов по поиску
    useEffect(() => {
        if (!firstRender) return;

        if (timer.current) clearTimeout(timer.current);

        timer.current = setTimeout(() => {
            dispatch(getSubscriptionsSagaAction({
                page: pagination.current,
                search,
                date: subscriptions.current_month
            }));
        }, 1000);
    }, [search]);

    // Получение списка абонементов для текущего месяца и текущего заведения
    useEffect(() => {

        if (!currentEstablishment) return;

        dispatch(getSubscriptionsSagaAction({ date: subscriptions.current_month }));

        if (!firstRender) {
            setFirstRender(true);
        }
    }, [currentEstablishment, subscriptions_active_only, subscriptions_inactive_only, sort]);

    return (
        <>
            <Header component={ <SubscriptionsHeader/> } />
            <SubscriptionForm/>
            { addSubscriptionForm.open && <AddSubscriptionForm/> }
            <SubscriptionCalendar/>
            <ExtendSubscriptionForm/>
            <RepayMoneyForm/>
            <FamilyForm/>
            <div className="page">
                {
                    current_subscription.current_workouts.length
                        ?
                        <CurrentWorkouts/>
                        :
                        <div className="page__content">
                            <div className="table__header">
                                <div className="subscriptions__count" data-full="Всего абонементов:" data-short="">{ all_subscriptions_count }</div>
                                <div className="table__caption subscriptions__caption">Список абонементов</div>
                            </div>
                            <div className="subscriptions__filters">
                                <div className={ `subscriptions__filter subscriptions__filter--active ${ subscriptions_inactive_only ? 'subscriptions__filter--disable' : '' }` }>
                                    <div className="checkbox__wrapper"
                                         onClick={ () => dispatch(subscriptionsActiveOnlyAction(!subscriptions_active_only)) }
                                    >
                                        <div className={ `checkbox ${ subscriptions_active_only ? 'checkbox--active' : '' } `}/>
                                        <div className="checkbox__caption">Скрыть неактивированные</div>
                                    </div>
                                </div>
                                <div className="subscriptions__filter subscriptions__filter--inactive">
                                    <div className="checkbox__wrapper"
                                         onClick={ () => dispatch(subscriptionsInactiveOnlyAction(!subscriptions_inactive_only)) }
                                    >
                                        <div className={ `checkbox ${ subscriptions_inactive_only ? 'checkbox--active' : '' } `}/>
                                        <div className="checkbox__caption">Архив абонементов</div>
                                    </div>
                                </div>
                            </div>
                            <div className="table">
                                <div className="table__row table__row--header subscription__table">
                                    <div className="table__cell table__cell--left">Имя</div>
                                    <div className="table__cell">Посещения</div>
                                    <div className={ `table__cell ${
                                        sort.table === 'subscription' && sort.field === 'buy_date' && sort.order === 'asc'
                                            ?
                                            'table__cell--asc'
                                            :
                                            sort.table === 'subscription' && sort.field === 'buy_date' && sort.order === 'desc'
                                                ?
                                                'table__cell--desc'
                                                :   'table__cell--sort'
                                    }` }
                                         onClick={ () => dispatch(sortAction({
                                             table: 'subscription',
                                             field: 'buy_date',
                                             order: sort.order === 'asc' ? 'desc' : 'asc'
                                         })) }
                                    >Приобретён</div>
                                    <div className={ `table__cell ${
                                        sort.table === 'subscription' && sort.field === 'activation_date' && sort.order === 'asc'
                                            ?
                                            'table__cell--asc'
                                            :
                                            sort.table === 'subscription' && sort.field === 'activation_date' && sort.order === 'desc'
                                                ?
                                                'table__cell--desc'
                                                :   'table__cell--sort'
                                    }` }
                                         onClick={ () => dispatch(sortAction({
                                             table: 'subscription',
                                             field: 'activation_date',
                                             order: sort.order === 'asc' ? 'desc' : 'asc'
                                         })) }
                                    >Активирован</div>
                                    <div className={ `table__cell ${
                                        sort.table === 'subscription' && sort.field === 'expire_date' && sort.order === 'asc'
                                            ?
                                            'table__cell--asc'
                                            :
                                            sort.table === 'subscription' && sort.field === 'expire_date' && sort.order === 'desc'
                                                ?
                                                'table__cell--desc'
                                                :   'table__cell--sort'
                                    }` }
                                         onClick={ () => dispatch(sortAction({
                                             table: 'subscription',
                                             field: 'expire_date',
                                             order: sort.order === 'asc' ? 'desc' : 'asc'
                                         })) }
                                    >Действителен</div>
                                    <div className={ `table__cell ${
                                        sort.table === 'subscription' && sort.field === 'type' && sort.order === 'asc'
                                            ?
                                            'table__cell--asc'
                                            :
                                            sort.table === 'subscription' && sort.field === 'type' && sort.order === 'desc'
                                                ?
                                                'table__cell--desc'
                                                :   'table__cell--sort'
                                    }` }
                                         onClick={ () => dispatch(sortAction({
                                             table: 'subscription',
                                             field: 'type',
                                             order: sort.order === 'asc' ? 'desc' : 'asc'
                                         })) }
                                    >Тип тренировок</div>
                                    <div className={ `table__cell ${
                                        sort.table === 'subscription' && sort.field === 'coach' && sort.order === 'asc'
                                            ?
                                            'table__cell--asc'
                                            :
                                            sort.table === 'subscription' && sort.field === 'coach' && sort.order === 'desc'
                                                ?
                                                'table__cell--desc'
                                                :   'table__cell--sort'
                                    }` }
                                         onClick={ () => dispatch(sortAction({
                                             table: 'subscription',
                                             field: 'coach',
                                             order: sort.order === 'asc' ? 'desc' : 'asc'
                                         })) }
                                    >Тренер</div>
                                    <div className="table__cell">Ограничения</div>
                                    <div className="table__cell">Сумма</div>
                                    <div className="table__cell">
                                        <div className="subscriptions__freeze"/>
                                    </div>
                                    <div className="table__cell"/>
                                    <div className="table__cell"/>
                                </div>
                                <div className="subscription__items">
                                    {
                                        subscriptions.subscriptions?.map(elem => {
                                            return <Subscription key={ elem.id } data={ elem }/>
                                        })
                                    }
                                </div>
                            </div>
                        </div>

                }
                <Pagination handler={ changePage }/>
            </div>
        </>
    );
};

export default Subscriptions;